import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { UserProfileTrainingCertificate } from '../models/user-profile-training-certificate'
import { UserProfileTrainingCertificateGateway } from './user-profile-training-certificate-gateway'
import { NextYearTrainingDetails } from '../models/next-year-training-details'

@Injectable()
export class NetworkUserProfileTrainingCertificateGateway extends UserProfileTrainingCertificateGateway {
    constructor(private http: HttpClient) {
        super()
    }

    getPendingTrainingCerificatesByOrgID(orgID: number): Observable<UserProfileTrainingCertificate[]> {
        return this.http.get<UserProfileTrainingCertificate[]>(`../api/GetPendingTrainingCertificatesByOrgID/${orgID}`)
    }

    OpenPlanYears(): Observable<number[]> {
        return this.http.get<number[]>(`../api/OpenPlanYears/`)
    }
    showTrainingCerificate(userProfileTrainingCertificateID: number) {
        window.open(`../api/GetTrainingCertificate/${userProfileTrainingCertificateID}`)
    }

    addNextYearTrainingForUser(
        userProfileID: number,
        planyear1: number,
        planyear2: number,
        userProfileTrainingCertificateID: number
    ): Observable<NextYearTrainingDetails> {
        return this.http.get<NextYearTrainingDetails>(
            `../api/AddPlanYearTrainingForUser/${userProfileID}/${planyear1}/${planyear2}/${userProfileTrainingCertificateID}`
        )
    }
    inValidTrainingCertificate(userProfileTrainingCertificateID: number): Observable<boolean> {
        return this.http.get<boolean>(`../api/InValidTrainingCertificate/${userProfileTrainingCertificateID}`)
    }
}
